import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, onDelete, onEdit}) => {
    const rows = [
        { label: 'Name', value: data.customerName || 'N/A', fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
        { label: 'Amount', value: data.paymentAmount },
        { label: 'Invoice', value: data.invoiceStr || '-' },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={moment(data.paymentDate).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
